import type { BodyStyle } from '~/contracts/home';

const homeFeedBodyStyles: BodyStyle[] = [
  {
    alt: 'SUVs',
    image: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/suv.png`,
    mobileImage: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/suv.png?width=80`,
    tabletImage: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/suv.png?width=150`,
    link: '/cars/suv'
  },
  {
    alt: 'Sedans',
    image: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/sedan.png`,
    mobileImage: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/sedan.png?width=80`,
    tabletImage: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/sedan.png?width=150`,
    link: '/cars/sedan'
  },
  {
    alt: 'Trucks',
    image: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/truck.png`,
    mobileImage: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/truck.png?width=80`,
    tabletImage: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/truck.png?width=150`,
    link: '/cars/truck'
  },
  {
    alt: 'Coupes',
    image: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/coupe.png`,
    mobileImage: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/coupe.png?width=80`,
    tabletImage: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/coupe.png?width=150`,
    link: '/cars/coupe'
  },
  {
    alt: 'Minivans',
    image: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/minivan.png`,
    mobileImage: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/minivan.png?width=80`,
    tabletImage: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/minivan.png?width=150`,
    link: '/cars/minivan'
  },
  {
    alt: 'Convertibles',
    image: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/convertible.png`,
    mobileImage: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/convertible.png?width=80`,
    tabletImage: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/convertible.png?width=150`,
    link: '/cars/convertible'
  },
  {
    alt: 'Wagons',
    image: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/wagon.png`,
    mobileImage: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/wagon.png?width=80`,
    tabletImage: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/wagon.png?width=150`,
    link: '/cars/wagon'
  },
  {
    alt: 'Hatchbacks',
    image: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/hatchback.png`,
    mobileImage: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/hatchback.png?width=80`,
    tabletImage: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/hatchback.png?width=150`,
    link: '/cars/hatchback'
  },
  {
    alt: 'Electric',
    image: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/electric.png`,
    mobileImage: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/electric.png?width=80`,
    tabletImage: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/electric.png?width=150`,
    link: '/cars/electric'
  },
  {
    alt: 'Hybrids',
    image: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/hybrid.png`,
    mobileImage: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/hybrid.png?width=80`,
    tabletImage: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/hybrid.png?width=150`,
    link: '/cars/hybrid'
  },
  {
    alt: 'Plug-in Hybrids',
    image: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/plug-in-hybrid.png`,
    mobileImage: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/plug-in-hybrid.png?width=80`,
    tabletImage: `${process.env.CVNA_APP_CDN_URL}/home-assets/nba/plug-in-hybrid.png?width=150`,
    link: 'cars/filters?cvnaid=eyJmaWx0ZXJzIjp7ImZ1ZWxUeXBlcyI6WyJQbHVnLUluIEh5YnJpZCJdfX0'
  }
];

export default homeFeedBodyStyles;
